import React, { useState, useEffect, useContext } from 'react';
import CryptoJS from 'crypto-js';

import './add-bls-data.scss';
import { default as t } from '../../../utils/i18n';
import queryString from 'query-string';
import { UserContext, ToasterContext } from '../../../context';
import { Input, ActionLink, AppTooltip, CommonToaster, Button } from '../../atoms';
import { Table } from 'rsuite';
import { UploadBlsExcel, BlsChooseCampaigns } from '../../molecules';
import InputGroup from 'rsuite/InputGroup';
import { DatePicker, DateRangePicker, InputPicker } from 'rsuite';
import { BlsService, DashService } from '../../../services';
import { ReactComponent as SaveIcon } from '../../../assets/svg/save.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/trash-outline.svg';
import { navigateUrl } from '../../../utils/malaRedirect';

const AddBlsData = props => {
  const location = queryString?.parse(window.location.search);
  const accountId = location?.accountId;
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const { message, setMessage } = useContext(ToasterContext);
  const [toaster, setToaster] = useState(false);
  const { Column, HeaderCell, Cell } = Table;
  const [questionTypes, setQuestionTypes] = useState('');

  const [uploadExcel, setUploadExcel] = useState(false);
  const [excelSuccessRes, setExcelSuccessRes] = useState([]);
  const [objectiveSuccessRes, setObjectiveSuccessRes] = useState([]);
  const [openSliderModal, setOpenSliderModal] = useState(false);
  const [isFieldActive, setIsFieldActive] = useState(false);

  const { allowedRange } = DateRangePicker;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateDisable, setStartDateDisable] = useState(false);
  const [endDateDisable, setEndDateDisable] = useState(true);
  let todayDate = new Date();
  let threeYearBeforedate = todayDate.setMonth(todayDate.getMonth() - 36);

  const handleBackClick = e => {
    props.handleBackClick(e);
  };

  const getWidth = (value = 10) => {
    return window.innerWidth / value;
  };
  const clearToaster = () => {
    setTimeout(() => {
      setToaster(false);
    }, 7000);
  };

  useEffect(() => {
    if (user?.isMalaRedirect && !user.dropdowns?.businessManager?.label) {
      getBusinessManager();
      getAdAccounts(user.dropdowns?.businessManager);
    }
    setMessage({});
    getQuestionTypes();
    setExcelSuccessRes([
      {
        studyId: '',
        studyName: '',
        startDate: new Date(threeYearBeforedate),
        endDate: new Date(),
        cells: [
          {
            id: '',
            name: `Cell 1`,
            experiments: [],
            selected: true,
          },
        ],
      },
    ]);
    setEndDateDisable(false);
  }, []);

  async function getBusinessManager() {
    try {
      const bmResponse = await DashService.bmList(userAccessToken, username);
      let selected;
      const list = bmResponse.data?.data;
      for (const businessMs of list) {
        const data = {
          value: businessMs.id,
          label: businessMs.name,
        };
        if (data.value === user.dropdowns?.businessManager?.value) {
          selected = data;
          break;
        }
      }

      if (selected) {
        setUser(prev => ({
          ...prev,
          dropdowns: {
            ...prev.dropdowns,
            businessManager: selected,
          },
        }));
      }
    } catch (error) {}
  }

  async function getAdAccounts(selectedOption) {
    try {
      const adAcResponse = await DashService.adAccountList(
        userAccessToken,
        username,
        selectedOption.value
      );
      let selected;
      const list = adAcResponse.data?.data;
      for (const adAccounts of list) {
        const data = {
          value: adAccounts.id,
          label: adAccounts.name,
        };
        if (data.value === user.dropdowns?.adaccount?.value) {
          selected = data;
          break;
        }
      }
      if (selected) {
        setUser(prev => ({
          ...prev,
          dropdowns: {
            ...prev.dropdowns,
            adaccount: selected,
          },
        }));
      }
    } catch (error) {}
  }

  const EditableCell = ({ rowData, dataKey, studyIndex, cIndex, onSelect, ...props }) => {
    return (
      <Cell {...props}>
        <span>
          <InputPicker
            {...props}
            defaultValue={rowData.questionType}
            data={questionTypes}
            placeholder={t('Question type')}
            onSelect={(e, item) => onSelect(e, item, rowData, studyIndex, cIndex)}
          />
        </span>
      </Cell>
    );
  };

  const InputCell = ({ rowData, dataKey, studyIndex, cIndex, onChange, ...props }) => {
    return (
      <Cell {...props}>
        <input
          {...props}
          className="rs-input"
          type={
            dataKey === 'advancedLift' ||
            dataKey === 'incrementalAdrecaller' ||
            dataKey === 'costPerIncrementalBreakthrough'
              ? 'number'
              : 'text'
          }
          key={`${dataKey}-${cIndex}`}
          defaultValue={rowData[dataKey]}
          onChange={e => onChange && onChange(e, dataKey, rowData, studyIndex, cIndex)}
        />
      </Cell>
    );
  };

  const ActionCell = ({ rowData, rowIndex, onSave, onDelete, studyIndex, cIndex, ...props }) => {
    return (
      <Cell {...props}>
        <div className="action_items">
          {/* <SaveIcon className="icon-size" onClick={() => onSave(rowData, studyIndex, cIndex)} /> */}
          {!isFieldActive && (
            <DeleteIcon
              className="icon-size-del"
              onClick={() => onDelete(rowData, studyIndex, cIndex)}
            />
          )}
        </div>
      </Cell>
    );
  };

  const onQuestionTypeSelect = (e, val, rowData, studyIndex, cIndex) => {
    excelSuccessRes[studyIndex].cells[cIndex].experiments.find(
      ex => ex.id === rowData.id
    ).questionType = val.value;
  };

  const onInputChange = (e, dataKey, rowData, studyIndex, cIndex) => {
    excelSuccessRes[studyIndex].cells[cIndex].experiments.find(ex => ex.id === rowData.id)[
      dataKey
    ] = e?.target?.value;
  };

  const onQuestionSave = (rowData, studyIndex, cIndex) => {
    setExcelSuccessRes([...excelSuccessRes]);
  };

  const onQuestionDel = (rowData, studyIndex, cIndex) => {
    let result = excelSuccessRes[studyIndex].cells[cIndex].experiments.filter(
      ex => ex.id !== rowData.id
    );
    excelSuccessRes[studyIndex].cells[cIndex].experiments = result;
    setExcelSuccessRes([...excelSuccessRes]);
  };

  const handleExcelModal = (val, successRes) => {
    if (successRes) {
      const updatedSuccessRes = successRes?.blsData;
      updatedSuccessRes[0].cells[0]['selected'] = true;
      setExcelSuccessRes(updatedSuccessRes);
      setObjectiveSuccessRes(successRes?.objectives);
      setIsFieldActive(true);
    }
    setUploadExcel(val);
  };

  const handleOpenPopup = () => {
    setUploadExcel(true);
  };

  const onStartDateChange = (val, currentStudyIndex) => {
    if (val && val !== null) {
      setStartDate(new Date(val));
      setEndDateDisable(false);
      setEndDate(null);
    } else {
      setStartDate(val);
      setEndDate(null);
      setEndDateDisable(true);
    }
    excelSuccessRes[currentStudyIndex].startDate = new Date(val);
    setExcelSuccessRes(excelSuccessRes);
  };

  const onEndDateChange = (val, currentStudyIndex) => {
    if (val && val !== null) {
      setEndDate(new Date(val));
      handleDateRange([new Date(startDate), new Date(val)]);
    } else {
      setEndDate(val);
    }
    excelSuccessRes[currentStudyIndex].endDate = new Date(val);
    setExcelSuccessRes(excelSuccessRes);
  };

  const handleDateRange = date => {
    setStartDate(new Date(date[0]));
    setEndDate(new Date(date[1]));
    let startDate = updateDateFormatApi(date[0]);
    let endDate = updateDateFormatApi(date[1]);
  };

  const updateDateFormatApi = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1;
    let dd = d.getDate();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return yyyy + '-' + mm + '-' + dd;
  };

  const handleInputchange = (e, index, key, cellIndex, isCell) => {
    if (isCell) {
      excelSuccessRes[index].cells[cellIndex][key] = e?.target?.value;
    } else {
      excelSuccessRes[index][key] = e?.target?.value;
    }
    setExcelSuccessRes([...excelSuccessRes]);
  };

  const onClickOfCells = (sIndex, cIndex) => {
    excelSuccessRes[sIndex].cells?.forEach(cell => (cell.selected = false));
    excelSuccessRes[sIndex].cells[cIndex]['selected'] = true;
    setExcelSuccessRes([...excelSuccessRes]);
  };

  const handleAddCells = sIndex => {
    excelSuccessRes[sIndex].cells?.forEach(cell => (cell.selected = false));
    excelSuccessRes[sIndex].cells.push({
      id: '',
      name: `Cell${excelSuccessRes[sIndex]?.cells?.length + 1}`,
      experiments: [],
      selected: true,
    });

    setExcelSuccessRes([...excelSuccessRes]);
  };

  const handleOpenSliderModal = (val, selectedCampaigns, sDate, eDate) => {
    if (selectedCampaigns) {
      excelSuccessRes.find(study => {
        study.cells.find(cell => cell.chooseCampaignsClicked).selectedCampaigns = selectedCampaigns;
        study.cells.find(cell => cell.chooseCampaignsClicked).startDate = sDate;
        study.cells.find(cell => cell.chooseCampaignsClicked).endDate = eDate;
      });
      setExcelSuccessRes([...excelSuccessRes]);
    }
    setOpenSliderModal(!openSliderModal);
  };

  const onViewAccounts = (e, sIndex, cIndex) => {
    e.preventDefault();
    excelSuccessRes[sIndex].cells.forEach(cell => (cell['chooseCampaignsClicked'] = false));
    excelSuccessRes[sIndex].cells[cIndex]['chooseCampaignsClicked'] = true;
    setExcelSuccessRes([...excelSuccessRes]);
    setOpenSliderModal(true);
  };

  const onAddQuestion = (e, sIndex, cIndex) => {
    e.preventDefault();
    excelSuccessRes[sIndex].cells[cIndex].experiments.push({
      id: '',
      questionType: '',
      pValue: '0',
      advancedLift: '',
      incrementalAdrecaller: '',
      costPerIncrementalBreakthrough: '',
    });
    setExcelSuccessRes([...excelSuccessRes]);
  };

  const SelectedCampaignsContainer = ({ cell, onClick, studyIndex, cIndex }) => {
    return (
      <div className="campaigns-list-container">
        <div className="list-scroll-container selected-container">
          <div className="list-scroll">
            {cell?.selectedCampaigns?.length && (
              <div className="selected_campaign_header">
                {t('bls.study.selected.campaigns')}({cell?.selectedCampaigns?.length})
              </div>
            )}
            <div className="selected-list">
              {cell?.selectedCampaigns?.map(item => {
                return (
                  <div className="selected-item" key={item.name}>
                    <span className="selected-value" title={item?.name}>
                      {item?.name}
                    </span>
                    <span className="cross" onClick={e => onClick(e, item, studyIndex, cIndex)}>
                      <i className="eva eva-close-outline clear-icon"></i>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const onRemoveAcc = (value, account, sIndex, cIndex) => {
    let resultedCampaigns = excelSuccessRes[sIndex].cells[cIndex].selectedCampaigns.filter(
      campaign => campaign.id !== account.id
    );
    excelSuccessRes[sIndex].cells[cIndex].selectedCampaigns = resultedCampaigns;
    setExcelSuccessRes([...excelSuccessRes]);
  };

  async function getQuestionTypes() {
    try {
      const bmResponse = await BlsService.getBlsQuestionTypes(userAccessToken, username);
      let types = bmResponse.data?.data?.map(res => ({
        label: res,
        value: res,
      }));
      setQuestionTypes(types);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  let checkBtnDisabled = () => {
    let btndisable = true;
    btndisable = user?.isMalaRedirect
      ? excelSuccessRes.every(study => !(study.studyId && study.studyName))
      : excelSuccessRes.every(study => study.studyId === '');
    excelSuccessRes.forEach(study => {
      study.btndisable = !study.cells.every(
        cell =>
          cell?.id &&
          cell?.name &&
          cell.id !== '' &&
          cell.name !== '' &&
          cell.experiments?.length &&
          cell?.selectedCampaigns?.length &&
          cell?.experiments?.length
      );
    });
    return btndisable || excelSuccessRes?.some(study => study.btndisable);
  };

  const onSubmitAdd = () => {
    let payloadRes = [];
    let objectivePayloadRes = objectiveSuccessRes;
    excelSuccessRes.forEach((study, index) => {
      payloadRes.push({
        studyId: study.studyId,
        studyName: study.studyName,
        startDate: study.startDate,
        endDate: study.endDate,
        cells: [],
        businessManagerId: user?.dropdowns?.businessManager?.value,
        adAccountId: user?.dropdowns?.adaccount?.value,
      });
      study?.cells?.forEach(cell => {
        payloadRes[index].cells.push({
          id: cell?.id,
          name: cell.name,
          campaigns: cell?.selectedCampaigns?.length
            ? cell?.selectedCampaigns?.map(campaign => ({ id: campaign?.id, name: campaign?.name }))
            : [],
          experiments: cell?.experiments,
        });
      });
    });
    const paylaod = { blsData: payloadRes, objectives: objectivePayloadRes };
    if (user?.isMalaRedirect) {
      paylaod['blsExperimentId'] = user?.redirectData?.blsData?.expId;
    }
    onsubmit(paylaod);
  };

  async function onsubmit(payload) {
    try {
      const result = await BlsService.onStudySubmit(userAccessToken, username, payload);
      setMessage({ message: t('bls.add.study.success'), isError: false });
      handleBackClick(true);
    } catch (error) {
      const errMsg = error?.data?.data?.message;
      setMessage({ message: errMsg, isError: true });
      setToaster(true);
      clearToaster();
    }
  }

  const getEncryptedParams = data =>
    CryptoJS.AES.encrypt(data, process.env.REACT_APP_AUTH_KEY).toString();

  const navigateUrl = async () => {
    const url = process.env.REACT_APP_MALA_URL;
    if (!url) return;
    // creating user data
    // used single characters like u, t, p due to url length limitations
    const userData = {
      u: user.username,
      r: user.redirectPath,
    };
    if (user.isSSO) {
      userData['t'] = user.tokens.idToken.jwtToken;
    } else {
      userData['p'] = user.password;
    }

    // encrypting user data
    const data = getEncryptedParams(JSON.stringify(userData));

    // creating link
    let element = document.createElement('a');
    if (url.startsWith('http://') || url.startsWith('https://')) {
      const uu = url + '/mala/' + btoa(data);
      element.href = uu;
    } else {
      element.href = 'http://' + url + '/mala/' + btoa(data);
    }

    // removing BB local storage
    localStorage.removeItem('user');
    window.location.replace('/');

    // navigating to url
    element.click();
  };

  return (
    <section>
      <div className="add_bls_container">
        <div className="business_account_details">
          <div className="heading-btn-container">
            <div className="header-holder">
              <button className="return-insights" onClick={() => handleBackClick()}>
                <i className="eva  eva-arrow-ios-back-outline"></i>
                {t('bls.back')}
              </button>
            </div>
            {user?.isMalaRedirect ? (
              <div className="mala-redirect-button">
                <Button
                  type="button"
                  label={t('Back to Manage Learning Agenda')}
                  handleClick={() => {
                    navigateUrl(user);
                  }}
                ></Button>
              </div>
            ) : null}
          </div>
          <div className="import-campaign-cta add_bls">
            <div className="accounts_header">
              {t('bls.study.for')}: &nbsp;{user?.dropdowns?.adaccount?.label}
            </div>
          </div>
          {excelSuccessRes?.length &&
            excelSuccessRes?.map((eachStudy, index) => {
              return (
                <div className="container_main">
                  <div className="account_details_container">
                    <div className="ad_ac_details">
                      <div>
                        <div className="ac_details_header">{t('bls.study.bm')}</div>
                        <div className="ac_details_val">
                          {user?.dropdowns?.businessManager?.label}
                        </div>
                      </div>
                      <div>
                        <div className="ac_details_header">{t('bls.study.ad.account')}</div>
                        <div className="ac_details_val">{user?.dropdowns?.adaccount?.label}</div>
                      </div>
                    </div>
                    <div className="btn_submit">
                      <button className="step-back" onClick={handleOpenPopup}>
                        {t('bls.upload.excel')}
                      </button>
                      <span
                        className="step-next"
                        data-tip={checkBtnDisabled() ? t('bls.metric.upload.btn.disabled') : ''}
                        data-for="tool-tip3"
                      >
                        {' '}
                        <button
                          className="step-back step-add"
                          onClick={onSubmitAdd}
                          disabled={checkBtnDisabled()}
                        >
                          {t('bls.study.submit')}
                        </button>
                      </span>
                      <AppTooltip
                        className="c-table-info-icon--tooltip"
                        id="tool-tip3"
                        place="left"
                      />
                    </div>
                  </div>
                  <CommonToaster message={message} toaster={toaster}></CommonToaster>
                  <div className="filter_container">
                    <div className="filter-section">
                      <div className="left-section">
                        <Input
                          isDisabled={user?.isMalaRedirect}
                          labelValue={t('bls.study.id')}
                          name="name"
                          fieldType="text"
                          placeholder={t('bls.study.id')}
                          value={eachStudy?.studyId}
                          handleChange={e => handleInputchange(e, index, 'studyId')}
                        />
                        <Input
                          labelValue={t('bls.study.name')}
                          name="token"
                          fieldType="text"
                          placeholder={t('bls.study.name')}
                          value={eachStudy?.studyName}
                          handleChange={e => handleInputchange(e, index, 'studyName')}
                          isMandatory={user?.isMalaRedirect}
                        />
                        <div className="bottom-section date_picker_width">
                          <InputGroup>
                            <DatePicker
                              id="start-date"
                              disabled={startDateDisable || user?.isMalaRedirect}
                              format="dd-MM-yyyy"
                              value={new Date(eachStudy?.startDate)}
                              onChange={e => onStartDateChange(e, index)}
                              disabledDate={allowedRange(new Date(threeYearBeforedate), new Date())}
                              placeholder={t('report.wrapper.start.date')}
                              oneTap
                            />
                            <InputGroup.Addon>to</InputGroup.Addon>
                            <DatePicker
                              id="end-date"
                              disabled={endDateDisable || user?.isMalaRedirect}
                              format={'dd-MM-yyyy'}
                              value={new Date(eachStudy?.endDate)}
                              onChange={e => onEndDateChange(e, index)}
                              disabledDate={allowedRange(startDate, new Date())}
                              placeholder={t('report.wrapper.end.date')}
                              oneTap
                            />
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="cells_container">
                    <div className="cells_group_choose">
                      <div className="btn_submit">
                        {eachStudy?.cells?.map((cell, cellIndex) => {
                          return (
                            <div>
                              {cell?.name && (
                                <button
                                  className={cell?.selected ? 'step-back step-add' : 'step-back'}
                                  onClick={() => onClickOfCells(index, cellIndex)}
                                >
                                  {cell?.name}
                                </button>
                              )}
                            </div>
                          );
                        })}
                        <button
                          className="step-back"
                          onClick={() => handleAddCells(index)}
                          disabled={isFieldActive || user?.isMalaRedirect}
                        >
                          +{t('bls.add.cells')}
                        </button>
                      </div>
                    </div>
                    {eachStudy?.cells?.map((cell, cellIndex) => {
                      if (cell?.selected) {
                        return (
                          <div className="individual_cell">
                            <div className="cell_name_header">{cell?.name}</div>
                            <div className="study_details">
                              <div className="filter-section">
                                <div className="left-section">
                                  <Input
                                    isDisabled={user?.isMalaRedirect}
                                    inputClassNames={user?.isMalaRedirect ? 'disabled-input' : ''}
                                    labelValue={t('bls.cell.id')}
                                    name="name"
                                    fieldType="text"
                                    placeholder={t('bls.enter.cell.id')}
                                    value={cell?.id}
                                    handleChange={e =>
                                      handleInputchange(e, index, 'id', cellIndex, true)
                                    }
                                  />
                                  <Input
                                    isDisabled={user?.isMalaRedirect}
                                    inputClassNames={user?.isMalaRedirect ? 'disabled-input' : ''}
                                    labelValue={t('bls.cell.name')}
                                    name="token"
                                    fieldType="textArea"
                                    placeholder={t('bls.enter.cell.name')}
                                    value={cell?.name}
                                    handleChange={e =>
                                      handleInputchange(e, index, 'name', cellIndex, true)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="choose_campaigns">
                              <i className="eva  eva-external-link-outline"></i>
                              <ActionLink
                                anchor={true}
                                disabled={user?.isMalaRedirect && !eachStudy?.studyId}
                                value={t('bls.choose.campaigns')}
                                handleClick={e => {
                                  onViewAccounts(e, index, cellIndex);
                                }}
                                isMandatory={true}
                              />
                            </div>
                            {cell?.selectedCampaigns?.length ? (
                              <SelectedCampaignsContainer
                                cell={cell}
                                onClick={onRemoveAcc}
                                studyIndex={index}
                                cIndex={cellIndex}
                              />
                            ) : (
                              ''
                            )}
                            <div className="questions_header">
                              <div className="question_title">{t('bls.questions')}</div>
                              <div>
                                <span className="view-details">
                                  <i className="eva  eva-arrow-forward-outline"></i>
                                  <ActionLink
                                    redirectTo={''}
                                    disabled={isFieldActive || user?.isMalaRedirect}
                                    value={t('bls.add.question')}
                                    handleClick={e => {
                                      onAddQuestion(e, index, cellIndex);
                                    }}
                                    isMandatory={true}
                                  />
                                </span>
                              </div>
                            </div>
                            <div className="question_table_container">
                              <div tabindex="0" id="table" className="table-container">
                                <Table
                                  height={400}
                                  bordered
                                  data={cell?.experiments}
                                  locale={{ emptyMessage: t('bls.empty.msg') }}
                                  onRowClick={rowData => {
                                    rowData.isSelected = true;
                                  }}
                                >
                                  <Column width={getWidth(8)}>
                                    <HeaderCell>
                                      {t('bls.exp.id')} <sup>*</sup>
                                    </HeaderCell>
                                    {/* <Cell dataKey="id"></Cell> */}
                                    <InputCell
                                      dataKey="id"
                                      disabled={isFieldActive}
                                      studyIndex={index}
                                      cIndex={cellIndex}
                                      onChange={onInputChange}
                                    />
                                  </Column>
                                  <Column width={getWidth(5)} align="left" fixed>
                                    <HeaderCell>
                                      {t('bls.choose.qtype')}
                                      <sup>*</sup>
                                    </HeaderCell>
                                    <EditableCell
                                      disabled={isFieldActive}
                                      dataKey="questionType"
                                      studyIndex={index}
                                      cIndex={cellIndex}
                                      onSelect={onQuestionTypeSelect}
                                    />
                                  </Column>

                                  <Column width={getWidth(5)} align="left" fixed>
                                    <HeaderCell>{t('blis.brand.study')} </HeaderCell>
                                    {/* <Cell dataKey="advancedLift" /> */}
                                    <InputCell
                                      dataKey="advancedLift"
                                      disabled={isFieldActive}
                                      studyIndex={index}
                                      cIndex={cellIndex}
                                      onChange={onInputChange}
                                    />
                                  </Column>

                                  <Column width={getWidth(6)} flexGrow={1} fixed>
                                    <HeaderCell>{t('bls.cost.per.lift')}</HeaderCell>

                                    {/* <Cell dataKey="costPerIncrementalBreakthrough"></Cell> */}
                                    <InputCell
                                      dataKey="costPerIncrementalBreakthrough"
                                      disabled={isFieldActive}
                                      studyIndex={index}
                                      cIndex={cellIndex}
                                      onChange={onInputChange}
                                    />
                                  </Column>
                                  <Column width={getWidth(6)} flexGrow={1} fixed>
                                    <HeaderCell>{t('bls.volume')}</HeaderCell>

                                    {/* <Cell dataKey="incrementalAdrecaller"></Cell> */}
                                    <InputCell
                                      dataKey="incrementalAdrecaller"
                                      disabled={isFieldActive}
                                      studyIndex={index}
                                      cIndex={cellIndex}
                                      onChange={onInputChange}
                                    />
                                  </Column>
                                  <Column width={getWidth(19)} flexGrow={1} fixed>
                                    <HeaderCell></HeaderCell>
                                    <ActionCell
                                      onSave={onQuestionSave}
                                      onDelete={onQuestionDel}
                                      studyIndex={index}
                                      cIndex={cellIndex}
                                    />
                                  </Column>
                                </Table>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              );
            })}
          {user?.isMalaRedirect ? (
            <div className="mala-redirect-button">
              <Button
                type="button"
                label={t('Back to Manage Learning Agenda')}
                handleClick={navigateUrl}
              ></Button>
            </div>
          ) : null}
        </div>
        {openSliderModal && (
          <BlsChooseCampaigns
            insightDetails={openSliderModal}
            handleModalBackClick={handleOpenSliderModal}
            totalRes={excelSuccessRes}
          />
        )}
        {uploadExcel && (
          <UploadBlsExcel addAccountsModal={uploadExcel} handleOpenSliderModal={handleExcelModal} />
        )}
      </div>
    </section>
  );
};

export default AddBlsData;
